var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2948 2.97822C11.0987 2.78383 10.7821 2.78524 10.5877 2.98137C10.3934 3.1775 10.3948 3.49408 10.5909 3.68847L11.5311 4.62037C11.9144 5.00023 12.1713 5.25592 12.344 5.471C12.346 5.47347 12.348 5.47592 12.3499 5.47836C12.3558 5.48569 12.3615 5.4929 12.367 5.50001H6.66683C4.54974 5.50001 2.8335 7.21625 2.8335 9.33334C2.8335 11.4504 4.54974 13.1667 6.66683 13.1667H12.0002C12.2763 13.1667 12.5002 12.9428 12.5002 12.6667C12.5002 12.3905 12.2763 12.1667 12.0002 12.1667H6.66683C5.10202 12.1667 3.8335 10.8982 3.8335 9.33334C3.8335 7.76854 5.10202 6.50001 6.66683 6.50001H12.367C12.3596 6.50949 12.352 6.51915 12.3441 6.52902C12.1713 6.7441 11.9144 6.99979 11.5311 7.37965L10.5909 8.31155C10.3948 8.50594 10.3934 8.82252 10.5877 9.01865C10.7821 9.21478 11.0987 9.21619 11.2948 9.0218L12.2556 8.0696C12.613 7.71533 12.9112 7.41986 13.1237 7.15518C13.3467 6.87757 13.5163 6.5858 13.5616 6.23034C13.5713 6.15387 13.5762 6.07694 13.5762 6.00001C13.5762 5.92308 13.5713 5.84615 13.5616 5.76968C13.5163 5.41422 13.3467 5.12245 13.1237 4.84484C12.9112 4.58016 12.6131 4.2847 12.2556 3.93045L11.2948 2.97822Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo);
export default __webpack_public_path__ + "static/media/Redo.62c17c3afba0058d9db7e876cb5bb8ea.svg";
export { ForwardRef as ReactComponent };